import styled from 'styled-components';
import { headerBorder, white } from '../../../../styles/colors';
import { toLarge, toMedium } from '../../../../styleUtils/mediaQueries';

export const Wrapper = styled.div`
    position: relative;
    padding: 1.5rem;
    border: ${headerBorder} solid 1px;
    ${toMedium`
    margin: 1.5rem 0;
  `};
    ${toLarge`
    margin: 0;
  `};
    height: fill-available;
    background-color: ${white};
`;
